/** Valuta u kojoj dolazi gotovo svaki ulazni račun; tečaj se traži tek kad je druga. */
export const DEFAULT_CURRENCY_ID = "eur";
